// extracted by mini-css-extract-plugin
export var linkContainer = "socialLinks-module--linkContainer--a4ca7";
export var socials = "socialLinks-module--socials--ab5b7";
export var socialsContainer = "socialLinks-module--socialsContainer--2ff06";